import { Checkbox, FormControlLabel, Grid, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ClinicPickerMaster } from "../../../../features/profile/component/chips/ChangeClinic";
import useUser from "../../../../hooks/useUser";
import UserHint from "../../../display/UserHint";
import { isEmptyString, mandatory } from "../../../../utils/Functions";
import { isMobilePhone } from "../../../../features/auth/utils/PhoneNumberValidation";
const XS_VALUE = 6;

export default function NewUserForm({ showSendEmail = true, requireNames = true }) {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { roles } = useUser();

  const { t } = useTranslation();

  return (
    <>
      <Grid item xs={XS_VALUE}>
        <Controller
          name="user.userDetails.firstName"
          control={control}
          rules={{ required: requireNames ? t("EmptyField") : false }}
          render={({ field }) => (
            <TextField
              error={!!errors.user?.userDetails?.firstName}
              helperText={errors.user?.userDetails?.firstName?.message}
              fullWidth
              label={requireNames ? mandatory(t("Name")) : t("Name")}
              inputProps={{
                maxLength: 120,
                "data-testid": "users.new-user-form.first-name-input",
              }}
              {...field}
            />
          )}
        />
      </Grid>
      <Grid item xs={XS_VALUE}>
        <Controller
          name="user.userDetails.lastName"
          control={control}
          rules={{ required: requireNames ? t("EmptyField") : false }}
          render={({ field }) => (
            <TextField
              error={!!errors.user?.userDetails?.lastName}
              helperText={errors.user?.userDetails?.lastName?.message}
              fullWidth
              label={requireNames ? mandatory(t("LastName")) : t("LastName")}
              inputProps={{
                maxLength: 120,
                "data-testid": "users.new-user-form.last-name-input",
              }}
              {...field}
            />
          )}
        />
      </Grid>
      <Grid item xs={XS_VALUE}>
        <Controller
          name="user.userDetails.email"
          control={control}
          render={({ field }) => (
            <TextField
              fullWidth
              label={t("Email")}
              type="email"
              inputProps={{ "data-testid": "users.new-user-form.email-input", maxLength: 254 }}
              {...field}
            />
          )}
        />
      </Grid>
      <Grid item xs={XS_VALUE}>
        <Controller
          name="user.userDetails.phoneNumber"
          control={control}
          rules={{
            validate: (value) =>
              isEmptyString(value) || //Leave isEmptyString, it's used to validate phone number only when a user writes a phone number
              isMobilePhone(value) ||
              t("InvalidPhoneNumber"),
          }}
          render={({ field }) => (
            <TextField
              fullWidth
              label={t("PhoneNumber")}
              error={!!errors.user?.userDetails?.phoneNumber}
              helperText={errors.user?.userDetails?.phoneNumber?.message || ""}
              inputProps={{
                "data-testid": "users.new-user-form.phone-number-input",
                maxLength: 17,
              }}
              {...field}
            />
          )}
        />
      </Grid>

      {showSendEmail && (
        <Grid item xs={roles.master ? 6 : 12}>
          <Controller
            name="user.userDetails.sendEmailNotifications"
            control={control}
            render={({ field }) => (
              <FormControlLabel
                {...field}
                sx={{
                  border: "1px solid gray",
                  borderRadius: 1,
                  p: 1,
                  ml: 0.2,
                  width: "100%",
                }}
                control={
                  <Checkbox
                    defaultChecked
                    inputProps={{
                      "data-testid": "users.new-user-form.send-email-checkbox",
                    }}
                  />
                }
                label={t("WantToReceiveEmailNotifications")}
              />
            )}
          />
        </Grid>
      )}
      {roles.master ? (
        <Grid item xs={6}>
          <ClinicPickerMaster />
        </Grid>
      ) : null}
      {showSendEmail && (
        <Grid item xs={12}>
          <UserHint hint={"SubscribesToEmailUserHintUserForm"} />
        </Grid>
      )}
    </>
  );
}
